import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import scrollToComponent from 'react-scroll-to-component';

import {cloneArray} from '../../../../../utils/data';
import {diamondImgUrl, diamondTitle, diamondPrice, compareValue} from '../../../../../utils/formatting';
import {getMinPrice} from '../../../../../utils/product';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import {ResultsControlsContainer} from './ResultsControls';
import {ResultsPaginationContainer} from './ResultsPagination';
import RhinoLoading from '../../../common/RhinoLoading';

class BandResults extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {

		super(props);
		this.state = {
      scrollPos: 0,
      tabSelected: 'results',

      resultsOpen: true,
    };

    // Bind event listeners
    this.getScrollPos = ::this.getScrollPos;
	}

	componentDidMount() {
    window.addEventListener('scroll', this.getScrollPos, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.getScrollPos, false);
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    })
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  selectTab(tabVal) {
    this.setState({ tabSelected: tabVal });
  }

  getFavesLength() {
    return this.props.product.compareBands.length.toString();
  }

  isFavoriteProduct(product) {
    if(!product) {
      return false;
    }

    for(let i = 0; i < this.props.product.compareBands.length; i++) {
      if(this.props.product.compareBands[i].sku == product.sku) {
        return true;
      }
    }
    return false;
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  toggleFavoriteProduct(product) {
    if(this.isFavoriteProduct(product)) {
      this.removeFavoriteProduct(product);
    } else {
      this.addFavoriteProduct(product);
    }
  }

  addFavoriteProduct(product) {
    let faves = cloneArray(this.props.product.compareBands);
    if(faves.length >= 4) {
      return;
    }
    faves.push(product);
    this.props.productCompareBand(faves);
    // this.setState({ 
    //   tabSelected: 'compare',
    // });
  }

  removeFavoriteProduct(product) {
    
    let currentIndex = null;
    let faves = cloneArray(this.props.product.compareBands);

    if(this.props.product.compareBands.length === 1) {
      this.props.productCompareBand([]);
      return;
    }

    for(let i = 0; i < faves.length; i++) {
      if(faves[i].sku == product.sku) {
        currentIndex = i;
        break;
      }
    }

    faves.splice(currentIndex, 1);
    this.props.productCompareBand(faves);
  }

  renderFavorites() {

    let faveItems = [null, null ,null, null];
    let noItems = false;

    const selectedLength = this.props.product.compareBands.length;
    if(selectedLength === 0) {
      noItems = true;
    }
    for(let i = 0; i < faveItems.length; i++) {
      if(i < selectedLength) {
        faveItems[i] = this.props.product.compareBands[i];
      }
    }


    return <div className='favesWrapper'>

      {noItems ? 
        <div className='noItemsMessage'>Select products to compare</div> :
        null
      }

      {faveItems.map((item, k) => {

        if(item === null) {
          return this.renderNullFave(k);
        }

        if(this.props.gender == 'mensband') {
          return this.renderMensBandFave(item, k);
        } else {
          return this.renderWomensBandFave(item, k);
        }

      })}
    </div>;
  }

  

  renderNullFave(idx) {
    return <div className={'faveItem faveEmpty'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='heartSection'>
        <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/comparelogo.svg' />
        <div>Compare men's and women's wedding bands here!</div>
      </div>
    </div>;
  }

  renderWomensBandFave(product, idx) {
    return <div className={'faveItem faveProduct'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='faveRemove' onClick={() => this.removeFavoriteProduct(product)}>&times;</div>
      <div className='faveProductInner'>
        <div className='faveImg' onClick={() => this.internalNav('band/' + product.sku)}>
          <img src={this.getProductMainImage(product)} />
        </div>
        <div className='faveTitle'>
          <div>{product.name.replace(/Ã©/g, 'é')}</div>
        </div>
        <div className='faveDataRow'>
          <div className='faveDataLabel'>Total Carat Wt:</div>
          <div className={'faveDataValue EllipsisElement'}>{product.ttw_dia} Ct.</div>
        </div>
        <div className='favePrice'>${getMinPrice(product).toLocaleString()}</div>
        <div className='faveAdd' onClick={() => this.internalNav('band/' + product.sku)}>View</div>
      </div>
    </div>;
  }
  
  renderMensBandFave(product, idx) {
    return <div className={'faveItem faveProduct'} key={idx}>
      <div className='compareInnerWrapper'>
        <div className='compareNumber'>{idx + 1}</div>
      </div>
      <div className='faveRemove' onClick={() => this.removeFavoriteProduct(product)}>&times;</div>
      <div className='faveProductInner'>
        <div className='faveImg' onClick={() => this.internalNav('band/' + product.sku)}>
          <img src={this.getProductMainImage(product)} />
        </div>
        <div className='faveTitle'>
          <div>{product.name.replace(/Ã©/g, 'é')}</div>
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>Metal Type:</div>
          <div className={'faveDataValue EllipsisElement'}>{compareValue(product.metal_type)}</div>
        </div>
        <div className='faveDataRow' style={{display: 'none'}}>
          <div className='faveDataLabel'>MM Width:</div>
          <div className={'faveDataValue EllipsisElement'}>{product.mm_width ? product.mm_width + ' mm' : ''}</div>
        </div>
        <div className='favePrice'>${getMinPrice(product).toLocaleString()}</div>
        <div className='faveAdd' onClick={() => this.internalNav('band/' + product.sku)}>View</div>
      </div>
    </div>;
  }

  prevPage() {
    this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
    this.scrollToResults();
  }

  nextPage() {
    this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
    this.scrollToResults();
  }

  setPage(pageNum) {
    this.props.productSetPage(parseInt(pageNum));
    this.scrollToResults();
  }

  scrollToResults() {
    if(!this.resultsSection) { return; }
    scrollToComponent(this.resultsSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  isMobile() {
    return window.innerWidth <= 1024;
  }

  getPageCount() {
    return this.isMobile() ? 24 : 23;
  }

  getBandResults() {

    const AD_POSITION = 4;

    let resultsArray = [];

    if(!this.props.product.productResults || this.props.product.productResults.length === 0) {
      return resultsArray;
    }

    for(let i = 0; i < this.props.product.productResults.length; i++) {

      if(i >= this.getPageCount() * this.props.product.currentPage) {
        break;
      }

      if(i < this.getPageCount() * (this.props.product.currentPage - 1)) {
        continue;
      }

      if(!this.isMobile() && resultsArray.length == AD_POSITION) {
        resultsArray.push({sku: 'ad'});
      }

      resultsArray.push(this.props.product.productResults[i]);
    }
    return resultsArray;
  }

  renderProductAd(keyNum) {
    if(this.props.gender == 'mensband') {
      return <div className={'bandItem adBannerItem'} key={keyNum} onClick={() => this.internalNav('mens-bands')}>
        <div className={'adInnerWrapper mensBandAd'}>
          <div className='adPrompt'><div>Browse Top Styles &gt;</div></div>
        </div>
      </div>
    } else {
      return <div className={'bandItem adBannerItem'} key={keyNum} onClick={() => this.internalNav('womens-bands')}>
        <div className={'adInnerWrapper womensBandAd'}>
          <div className='adPrompt'><div>Browse Top Styles &gt;</div></div>
        </div>
      </div>
    }
  }

	render() {

    const RESULT_LIMIT = 24;
    let bCount = 0;

		return <div className='BandResults'>

			<div className='labelSection' style={{display: 'none'}}>
        <div className='labelTitle'>Featured Rings</div>
      </div>
      
      <div className={'resultsWrapper'} ref={(div) => { this.resultsSection = div; }}>
        
        <div className='resultsTabWrapper desktopOnly'>
          <div className={this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab'} onClick={() => this.selectTab('results')}>Results</div>
          <div className={this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab'} onClick={() => this.selectTab('compare')}>Compare Bands ({this.getFavesLength()} of 4)</div>
        </div>
        <div className='resultsTabWrapper mobileOnly'>
          <div className={this.state.tabSelected == 'results' ? 'resultsTab selectedTab' : 'resultsTab'} onClick={() => this.selectTab('results')}>Results</div>
          <div className={this.state.tabSelected == 'compare' ? 'resultsTab selectedTab' : 'resultsTab'} onClick={() => this.selectTab('compare')}>Compare ({this.getFavesLength()} of 4)</div>
        </div>
        {this.state.tabSelected == 'results' ?

          <div className='resultsBody' ref={(div) => { this.resultsBody = div; }}>
            <ResultsControlsContainer
              resultCount={this.props.product.productResultsCount}
              resultType={this.props.gender}
              openFilters={this.props.openFilters} />
            <div className='resultItemsWrapper'>
              {this.props.product.productResults !== null ?
                <div>
                  {this.props.product.productResults.length === 0 ?
                    <div className="noResults">
                      No results matching your search criteria.  Please adjust the filters and try again.
                    </div> :
                    <div className='resultsInternalWrapper'>
                      {this.getBandResults().map((product, j) => {

                        // if(product.image_count === 0 || bCount >= RESULT_LIMIT * this.props.product.currentPage) {
                        //   return null;
                        // }

                        // if(bCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
                        //   bCount++;
                        //   return null;
                        // }

                        if(product.sku == 'ad') {
                          return this.renderProductAd(j);
                        }

                        bCount++;

                        return <div className={this.isFavoriteProduct(product) ? 'bandItem favProduct' : 'bandItem'} key={j}>
                          
                          <div className='productItemInnerWrapper'>

                            <Link to={'/jewelry/' + product.sku}>
                              <div className='diamondItemImgWrapper'>
                                <img src={this.getProductMainImage(product)} />
                              </div>
                              <div className='productItemTitle'><div>{product.name.replace(/Ã©/g, 'é')}</div></div>
                              <div className='diamondItemPrice'>
                                ${getMinPrice(product).toLocaleString()}
                              </div>
                            </Link>
                            <div className='favSelectWrapper' onClick={() => this.toggleFavoriteProduct(product)}>
                              {this.isFavoriteProduct(product) ? 
                                <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' /> :
                                <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' />
                              }
                            </div>
                          </div>
                          
                        </div>
                      })}
                      <ResultsPaginationContainer
                        pageNum={parseInt(this.props.product.currentPage)}
                        pageNext={::this.nextPage}
                        pagePrev={::this.prevPage}
                        setPage={::this.setPage}
                        pageSize={this.getPageCount()}
                        resultCount={bCount} />
                    </div>
                  }
                </div> :
                <RhinoLoading />
              } 
            </div>
          </div> :
          <div className='picksPreview'>{this.renderFavorites()}</div>
        }
      </div>


		</div>;
	}
}
export default BandResults;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const BandResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(BandResults);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/BandResults.jsx